// 무료 도구 목록·공개 경로 — 목록 화면·랜딩·사이트맵·robots 가 같은 한 벌을 쓴다(cta 는 랜딩 링크 글자).
export const TOOL_LINKS = [
  {
    href: "/tools/forms/contract",
    title: "인테리어 계약서 양식",
    summary: "공정위 실내건축·창호, 국토부 민간건설공사 표준계약서 빈 양식을 그대로 인쇄합니다.",
    cta: "양식 열기",
  },
  {
    href: "/tools/forms/quote",
    title: "인테리어 견적서 양식",
    summary: "빈 견적서 인쇄 · 엑셀 양식 내려받기. 채운 엑셀은 buildpy로 바로 가져옵니다.",
    cta: "양식 열기",
  },
  {
    href: "/tools/notice",
    title: "공사 안내문 만들기",
    summary: "엘리베이터에 붙일 A4 공사 안내문. 상담 QR 을 넣을 수 있습니다.",
    cta: "안내문 만들기",
  },
  {
    href: "/tools/ohouse-cost",
    title: "오늘의집 광고비 계산기",
    summary: "월 광고비 ÷ 계약 건수 — 계약 1건에 드는 광고비를 사장님 숫자로 봅니다.",
    cta: "계산해 보기",
  },
] as const;

export const PUBLIC_PATHS: readonly string[] = ["/", "/pricing", "/terms", "/privacy", "/demo", "/tools", ...TOOL_LINKS.map((t) => t.href)];

// 시공사례 목록·상세만 /s/ 에서 열어 둔다 — 더 긴 규칙이 이기므로 embed 는 다시 막힌다.
export const ROBOTS_ALLOW: readonly string[] = ["/", "/s/portfolio/"];

// /signup 은 /signup/verify 까지 막는다(앞부분 일치).
export const ROBOTS_DISALLOW: readonly string[] = ["/app", "/s/", "/s/portfolio/*/embed", "/c/", "/api", "/login", "/signup", "/onboarding", "/reset-password", "/forgot-password", "/invite"];
